// select variant

let selects = document.querySelectorAll('.product-size select');
let productForm = document.querySelector('product-form');
for(let i=0; i<selects.length;i++){
    $(selects[i]).change(function(e) {
        ChangeVariant();
        this.form.querySelector('.error-option').innerHTML = ``;
    });
}

let selectedValues;
let checkedOptions_g;
let currentVariant;

function ChangeVariant(e){
    GetOptions();
    GetVariantId();
    UpdateUrl();
    UpdateContent();
    updateButton();
}
function GetOptions() {
    selectedValues = Array.from(document.querySelectorAll('.product-size select')).find((select) => select.value).value;
    const allSelect = document.querySelectorAll('.product-size select');
    let checkedoptions = [];
    allSelect.forEach(function (item){
        if(item.value == 'related_product'){
            let url = item.options[item.selectedIndex].dataset.url;
            window.location.replace(url);
        }else{
            checkedoptions.push(item.value);
        }
    })
    checkedOptions_g = checkedoptions;
}
function GetVariantId(){
    const variantJson = JSON.parse(document.querySelector('.product-page_controls [type="application/json"]').textContent)
    currentVariant = variantJson.find((variant) => variant.title === checkedOptions_g.join(' / '));
}
function UpdateUrl(){
    if (currentVariant){
        window.history.replaceState({ }, '', `${productForm.dataset.url}?variant=${currentVariant.id}`);
    }else{
        window.history.replaceState({ }, '', `${productForm.dataset.url}`);
    }
}
function UpdateContent(){
    if(currentVariant != undefined){
        productForm.querySelector('form input[name="id"]').value = currentVariant.id;
        productForm.classList.add('loading');

        fetch(`${productForm.dataset.url}?variant=${currentVariant.id}&section_id=${productForm.dataset.section}`)
            .then((response) => {
                return response.text();
            })
            .then((response_html) => {
                const html = new DOMParser().parseFromString(response_html, 'text/html')

                const fetchProductPrice = html.querySelector('[data-price]');
                const fetchProductAddCart = html.querySelector('.btn-add-cart');

                const productPrice = document.querySelector('[data-price]');
                const productAddCart = document.querySelector('.btn-add-cart');


                if(fetchProductPrice && productPrice){
                    productPrice.innerHTML = fetchProductPrice.innerHTML;
                }
                if(fetchProductAddCart && productAddCart){
                    productAddCart.parentNode.replaceChild(fetchProductAddCart, productAddCart);
                }

                productForm.classList.remove('loading');

            }) .catch((e) => {
            console.error(e);
        });
    }else{
        productForm.querySelector('form input[name="id"]').value = '';
    }
}

function updateButton() {
    if(productForm.querySelector('[name=id]').value != ''){
        productForm.querySelector('button[type="submit"]').removeAttribute('disabled');
        productForm.querySelector('button[type="submit"]').textContent = window.product.add_to_cart;
    }else{
        productForm.querySelector('button[type="submit"]').disabled = true;
        productForm.querySelector('button[type="submit"]').textContent = window.product.chose_variant_short;
    }
}




// select variant

//product form
if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this));
        }

        formSubmit(evt) {
            evt.preventDefault();
            this.classList.add('loading');
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            config.body = formData;
            console.log('formData', this.form.querySelector('input[name="id"]').value)
        if(this.form.querySelector('input[name="id"]').value == ''){
            this.form.querySelector('.error-option').innerHTML = `<span>${window.product.chose_variant}</span>`;
            this.classList.remove('loading');
        }else{
            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    this.classList.remove('loading');
                    this.succses(response);

                })
                .catch((error) => {
                    this.classList.remove('loading');
                    alert(error);
                    console.log(error);
                });
        }

        }
        errorMessage(resp) {
            this.classList.remove('loading');
            alert(resp.description)
            console.log(resp.description);
        }
        succses(res) {
            initCart();
            renderCart();
            document.querySelector('[data-cart-name]').click();
        }
    });
}
//product form

// product look form
if(document.querySelector('[js-product] .complete-look_product-btn') !== null){
    let productLook = document.querySelector('[js-product] .complete-look');
    productLook.querySelector('.complete-look_product-btn').addEventListener('click', function (e){
        e.preventDefault();
        productLook.classList.add('loading');
        let select = productLook.querySelector('select');
        let id = select.value;
        if(id != 'blank'){
            productLook.querySelector('.error-option').innerHTML = ``;
            let formData = {
                'items': [{
                    'id': id,
                    'quantity': 1
                }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    productLook.classList.remove('loading');
                    initCart();
                    renderCart();
                    document.querySelector('[data-cart-name]').click();
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });

        }else{

            productLook.querySelector('.error-option').innerHTML = `<span>${window.product.chose_variant}</span>`;

            productLook.classList.remove('loading');
        }
    })
}
// product look form




function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}
